import React, { ReactNode } from "react";
import ContactUs from "../ContactUs/ContactUs";
import TopBar from "../TopBar";
import SocialIcons from "../SocialIcons";
import "./Layout.css";
interface LayoutProps {
  children: ReactNode;
  hideFooter?: boolean;
  hideMenuLogo?: boolean;
  hideSocialIcons?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  hideFooter = false,
  hideMenuLogo = false,
  hideSocialIcons = false,
}) => {
  return (
    <div className="layout">
      <div>
        <TopBar hideMenuLogo={hideMenuLogo} />
        {!hideSocialIcons && <SocialIcons />}
        <main>{children}</main>
      </div>
      {!hideFooter && <ContactUs />}
    </div>
  );
};

export default Layout;
